import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'spaq-app-account-disabled',
	standalone: true,
	imports: [RouterModule],
	template: `
		<h4 class="text-center bg-warning p-4">
			Votre dossier requiert actuellement une intervention de notre équipe. Certaines fonctionnalités pourraient être limitées. Nous vous invitons à
			communiquer avec le service à la clientèle de la SPAQ afin de régulariser votre situation.
		</h4>
		<a routerLink="/auth/login/email" class="btn btn-secondary mt-4">Retour à la connexion</a>
	`,
	styles: []
})
export class AppAccountDisabledComponent {}
